<app-dialog-heading [heading]="'Create ATC Code'"></app-dialog-heading>
<div class="dialog-content">
    <form [formGroup]="atcFormGroup">
        <mat-form-field>
            <mat-label>ATC Code</mat-label>
            <input matInput type="text" [formControl]="codeFormControl" required>
        </mat-form-field>
        <br>
        <mat-form-field>
            <mat-label>ATC Name</mat-label>
            <input matInput type="text" [formControl]="nameFormControl" required>
        </mat-form-field>
        <br>
        <mat-form-field>
            <mat-label>Level</mat-label>
            <input matInput type="text" [formControl]="levelFormControl" required>
        </mat-form-field>
        <br>
        <mat-form-field>
            <mat-label>Source</mat-label>
            <input matInput type="text" [formControl]="sourceFormControl" required>
        </mat-form-field>
    </form>
    <p style="color: red">{{errorMessage}}</p>
</div>
<mat-dialog-actions align="center" class="dialog-button-container">
    <button class="dialog-button" mat-raised-button (click)="onSaveClick()" color="primary">Save</button>
    <button class="dialog-button" mat-raised-button (click)="onCancelClick()" color="warn" >Cancel</button>
</mat-dialog-actions>
